import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, MessageService, Task, TaskService } from '../../../../core';
import { IntegrationTransportadora } from './integration-transportadora';
import { IntegrationPeriodicidade, periodicidadeDiaria, isPeriodicidadeDiaria, periodicidadeSemanal, isPeriodicidadeSemanal, periodicidadeMensal, isPeriodicidadeMensal, periodicidadeAnual, isPeriodicidadeAnual, periodicidadeGeral, isPeriodicidadeGeral } from '../integration-periodicidade';
import { IntegrationTransportadoraHttpService } from './services';

@Component({
    selector: 'sgt-integration-transportadora-modal',
    templateUrl: './integration-transportadora-modal.component.html',
    styleUrls: ['./integration-transportadora-modal.component.less']
})
export class IntegrationTransportadoraModalComponent implements OnInit {
    entity = new IntegrationTransportadora();
    elModal: any;
    @Output() afterExecuteIntegration = new EventEmitter<any>();

    @ViewChild('form') form: NgForm;
    periodicidades: IntegrationPeriodicidade[] = [
        periodicidadeDiaria,
        periodicidadeSemanal,
        periodicidadeMensal,
        periodicidadeAnual,
        periodicidadeGeral
    ];

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private taskService: TaskService,
                private integrationTransportadoraHttpService: IntegrationTransportadoraHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                jQuery(this.elModal).find('#integrationTransportadoraPeriodicidade').trigger('focus');
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    private clear() {
        // this.form.resetForm();
        this.entity.clear();
    }

    open() {
        this.clear();

        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    private beforeExecute() {
        if (!this.isPeriodicidadeGeral()) {
            this.entity.dataCadastroBase = null;
        }
    }

    /** Executa a integração de leitura das transportadoras com os sistemas ERP's */
    execute() {
        if (this.form.valid) {
            this.beforeExecute();

            const task = new Task('Sincronizando transportadoras com o ERP', 'Executando sincronização das transportadoras com o sistema ERP');
            this.taskService.add(task, task.description);
            this.integrationTransportadoraHttpService.execReadIntegration(this.entity)
                .subscribe(
                    () => {
                        this.taskService.success(task, 'Sincronização das transportadoras com o sistema ERP realizada com sucesso');
                        this.afterExecuteIntegration.emit();
                    },
                    (error: ApiError) => this.taskService.error(task, 'Erro ao realizar a sincronização das transportadoras com o sistema ERP', error.message, error)
                );

            this.close();
        } else {
            this.messageService.info('Informe todos os campos corretamente para executar a sincronização das transportadoras com o ERP', 'Informação');
        }
    }

    /** Verifica se a periodicidade selecionada é geral */
    isPeriodicidadeGeral(): boolean {
        if (!this.entity) {
            return false;
        }
        return isPeriodicidadeGeral(this.entity.periodicidade);
    }

    getDescricaoPeriodicidade(periodicidade: number): string {
        if (isPeriodicidadeDiaria(periodicidade)) {
            return 'Diária - Transportadoras cadastradas nas últimas 24 horas';
        } else if (isPeriodicidadeSemanal(periodicidade)) {
            return 'Semanal - Transportadoras cadastradas nos últimos 7 dias';
        } else if (isPeriodicidadeMensal(periodicidade)) {
            return 'Mensal - Transportadoras cadastradas a partir do mês anterior';
        } else if (isPeriodicidadeAnual(periodicidade)) {
            return 'Anual - Transportadoras cadastradas a partir do ano anterior';
        } else if (isPeriodicidadeGeral(periodicidade)) {
            return 'Geral - Transportadoras cadastradas a partir de uma data específica'
        }
        return '';
    }
}
